import { Provider } from '@angular/core';

import { CreateJobService } from '../Domain/Port/CreateJob/create-job.service';
import { BackendCreateJobService } from '../Infrastructure/Adapter/CreateJob/backend-create-job.service';

export const provideCreateJobService = (): Provider[] => {
    return [
        {
            provide: CreateJobService,
            useExisting: BackendCreateJobService
        }
    ];
};
